import { useState } from 'react'
import { Form, Input, Button, Alert, Result } from 'antd'
import { MailOutlined, ArrowLeftOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import axiosInstance from '@/lib/axios'
import { API_ENDPOINTS } from '@/config/api'

const ForgotPasswordPage = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const onFinish = async (values: { email: string }) => {
    setError(null)
    setLoading(true)
    try {
      await axiosInstance.post(API_ENDPOINTS.FORGOT_PASSWORD, { email: values.email })
      setSubmitted(true)
    } catch {
      setError('Errore di connessione. Riprova tra qualche momento.')
    } finally {
      setLoading(false)
    }
  }

  if (submitted) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--color-bg-container)', padding: 24 }}>
        <Result
          status="success"
          title="Email inviata"
          subTitle="Se l'indirizzo email è registrato, riceverai le istruzioni per reimpostare la password entro pochi minuti. Controlla anche la cartella spam."
          extra={
            <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/')}>
              Torna al login
            </Button>
          }
        />
      </div>
    )
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--color-bg-container)', padding: 24 }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 26, fontWeight: 700, color: 'var(--color-text)', margin: '0 0 8px', letterSpacing: '-0.01em' }}>
            Password dimenticata?
          </h2>
          <p style={{ fontSize: 14, color: 'var(--color-text-secondary)', margin: 0 }}>
            Inserisci la tua email. Ti invieremo un link per reimpostare la password.
          </p>
        </div>

        {error && (
          <Alert type="error" message={error} showIcon style={{ marginBottom: 20 }} />
        )}

        <Form layout="vertical" onFinish={onFinish} size="large">
          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: 'Inserisci la tua email' },
              { type: 'email', message: 'Email non valida' },
            ]}
          >
            <Input
              prefix={<MailOutlined style={{ color: '#bfbfbf' }} />}
              placeholder="mario.rossi@example.com"
              autoComplete="email"
            />
          </Form.Item>

          <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
            <Button
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate('/')}
              style={{ height: 48 }}
            >
              Indietro
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              style={{ height: 48, fontWeight: 600 }}
            >
              Invia istruzioni
            </Button>
          </div>
        </Form>
      </div>
    </div>
  )
}

export default ForgotPasswordPage
